<template>
  <div v-if="$auth.isAuthenticated" :class="['master',{'menu-expanded':appState.menuExpanded}]">
    <StationList
      v-if="!isStationUidValid || displayStations"
      :canBeClosed="currentStation ? true : false"
      :currentStation="currentStation"
    >Choose station place holder</StationList>
    <PageHeader />
    <div class="master-content">
        <LeftMenu v-if="isStationUidValid" class="left-menu" />
      <div class="page-content">
        <router-view class="page" />
      </div>
    </div>
    <ClockCreationCard v-if="isCreatingClock" />
    <BoxCreationCard v-if="isCreatingBox" />
    <DayTemplateCreationCard v-if="isCreatingDayTemplate" />
    <div id="notifs">
      <notification-box />
      <file-transfers id="transfers" />
    </div>
    <span id="drag-ghost" class="ghost"></span>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import store from "@/store/index";
import StationList from "@/components/common/StationsList";
import PageHeader from "./components/common/Header.vue";
import LeftMenu from "./components/common/LeftMenu.vue";
import Constants from "@/store/constants";
import EventBus from "@/eventbus";
import ClockCreationCard from "@/components/Clocks/ClockCreationCard";
import BoxCreationCard from "@/components/Boxes/BoxCreationCard.vue";
import DayTemplateCreationCard from "@/components/DayTemplates/DayTemplateCreationCard.vue";
import NotificationBox from "@/components/common/NotificationBox";
import Regex from "@/apis/regex";
import FileTransfers from "@/components/common/FileTransfers.vue";
import { HTTP } from "@/utils/http";

export default {
  name: "app",
  components: {
    PageHeader,
    LeftMenu,
    StationList,
    ClockCreationCard,
    BoxCreationCard,
    DayTemplateCreationCard,
    NotificationBox,
    FileTransfers
  },
  //  created(){
  //    console.log('created')
  //   if (this.$auth0){
  //     const accessToken =  this.$auth0.getAccessTokenSilently();
  //     console.log(accessToken)
  //   }
  //
  // },
  mounted() {
    if (this.$route.params != null && this.$route.params.stationUid != null) {
      store.dispatch("activateStationByUid", this.$route.params.stationUid);
    }

    EventBus.$on("onBoxDuplicate", this.onBoxDuplicate);
    EventBus.$on("displayStationsList", this.displayStationsList);
    EventBus.$on("hideStationsList", this.hideStationsList);
    EventBus.$on("onUploadFile", this.onUploadModalOpen);
    EventBus.$on("dragStart", this.onDragStart);
    EventBus.$on("dragEnd", this.onDragEnd);
  },
  data() {
    return {
      Constants,
      displayStations: false
    };
  },
  computed: {
    ...mapState({
      appState: state => state.viewState,
      currentUser: state => state.user,
      currentStation: state => state.currentStation,
      isCreatingBox: state => state.loadingStates.isCreatingBox,
      isCreatingClock: state => state.loadingStates.isCreatingClock,
      isCreatingDayTemplate: state => state.loadingStates.isCreatingDayTemplate,
      isStationUidValid() {
        if (this.$route.params.stationUid == null) return false;
        return this.$route.params.stationUid.match(Regex.UUID);
      }
    }),
    Translations: function() {
      return Translations;
    },
    context() {
      return Constants.context;
    }
  },
  watch: {
    "$route.params.stationUid": function() {
      store.dispatch("activateStationByUid", this.$route.params.stationUid);
    }
  },

  methods: {
    ...mapMutations(["logout"]),
    displayStationsList() {
      this.displayStations = true;
    },
    hideStationsList() {
      this.displayStations = false;
    },
    async onBoxDuplicate(boxUid) {
      try {
        const response = await HTTP.post("/api/boxes/duplicate", {
          stationUid: this.$route.params.stationUid,
          boxUid
        });

        const data = await response.data.dataItem;

        await store.dispatch("loadStationBoxes", this.$route.params.stationUid);
        await this.$router.push({
          name: "BoxDetails",
          params: {
            boxUid: data.uid
          }
        });
      } catch (e) {
        console.log("error duplicat box :", e);
      }
    },
    onUploadModalOpen() {},
    onDragStart() {
      document.body.classList.add("drag-active");
    },
    onDragEnd() {
      document.body.classList.remove("drag-active");
    }
  }
};
</script>
<style lang='scss'>
@import "assets/css/style-storever.scss";
* {
  --HEIGHT_HEADER: 50px;
  --HEIGHT_PAGECONTENT: calc(100% - 50px);
  --HEIGHT_PAGE: calc(100% - 20px);
  --WIDTH-LEFTMENU: 290px;
  --PADDING_PAGECONTENT: 10px;
  // --COLOR_BRAND: #ff6a00;
  --COLOR_BRAND: #d2d2d2;
  --COLOR_BRAND2: #EA8F34;
  --COLOR_BRAND_TRANSPARENT: #ffdec6;
  --COLOR_BORDERS: #d2d2d2;
  --COLOR_BACKGROUND: #f0f1f3;
  --COLOR_TEXT: #212529;
}

html {
  height: 100%;
}

body {
  height: 100%;
  background: var(--COLOR_BACKGROUND);
}

/*--------------------------------------------------------------------------------*/
div.master {
  height: 100%;
}
/*--------------------------------------------------------------------------------*/
div.master > header {
  height: var(--HEIGHT_HEADER);
  background: var(--COLOR_BRAND);
  display: flex;
  color: white;
}
div.master > header .header-left {
  width: var(--WIDTH-LEFTMENU);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12.5px;
  box-shadow: 2px 0 5px -2px #9D9D9C;
}
div.master > header .header-left img {
  height: 45px;
}
div.master > header .header-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12.5px;
  flex-grow: 1;
}
div.master > header .header-right .breadscrum {
  font-size: 20px;
}
div.master > header .header-right .actions > * {
  margin: 5px 10px;
}
div.master > header .header-right .actions a,
div.master > header .header-right .actions a:hover {
  color: white;
}
/*--------------------------------------------------------------------------------*/
div.master > div.master-content {
  height: var(--HEIGHT_PAGECONTENT);
  overflow: auto;
  display: flex;
}

div.master > div.master-content > div.left-menu {
  width: var(--WIDTH-LEFTMENU);
  height: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  justify-content: flex-start;
  background: white;
  box-shadow: 2px 0 5px -2px var(--COLOR_BORDERS);
}

div.master > div.master-content > div.page-content {
  padding: var(--PADDING_PAGECONTENT);
  flex-grow: 1;
  width: calc(-290px + 100%);
  background: var(--COLOR_BACKGROUND);
}

div.master > div.master-content > div.page-content > .page {
  width: 100%;
  height: 100%;
}

div.master > div.master-content > div.page-content > .page div.right-panel {
  width: 290px;
  margin-left: 10px;
}
/*--------------------------------------------------------------------------------*/
div.master > footer {
  height: var(--HEIGHT_FOOTER);
  background: var(--COLOR_BRAND);
}
/*--------------------------------------------------------------------------------*/
section.page-section,
*.pad {
  padding: 15px;
}

.ghost {
  position: absolute;
  top: 0;
  padding: 10px 15px;
  border-radius: 3px;
  background-color: white;
  color: var(--COLOR_BRAND);
  left: -500px;
}
div#transfers {
  overflow: hidden;
}
</style>
